import { AfterViewInit, Component, OnInit } from '@angular/core';

// Service
import { ApiService } from 'src/app/shared/service/api.service';

declare const TradingView: any;

@Component({
  selector: 'app-widget-shareholding',
  templateUrl: './widget-shareholding.component.html'
})
export class WidgetShareholdingComponent implements OnInit, AfterViewInit {
  
  lang;
  isLang;

  constructor( private apiService: ApiService ) { }

  ngOnInit(): void {
    //MultiLanguage
   this.isLang =  this.apiService.isLang();
  }

  ngAfterViewInit() {
    this.apiService.lang.subscribe(response => {
      this.lang = response;
    });
    
    new TradingView.MediumWidget(
      {
        "symbols": [
          [
            "IDX:SGRO|1M"
          ]
        ],
        "chartOnly": false,
        "width": "100%",
        "height": 270,
        "locale": this.lang,
        "colorTheme": "light",
        "gridLineColor": "#F0F3FA",
        "trendLineColor": "#2196F3",
        "fontColor": "#787B86",
        "underLineColor": "#E3F2FD",
        "isTransparent": true,
        "autosize": true,
        "container_id": "tradingview_3d5dba"
      }
    );
  }

}
